import { styled } from '@mui/material';

export const StyledMultiSelect = styled('div')`
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
}
`;

export const HelperText = styled('span')(({ theme, type }) => {
  let color = theme.palette.text.secondary;

  if (type === 'error') {
    color = theme.palette.error.main;
  } else if (type === 'success') {
    color = theme.palette.success.main;
  } else if (type === 'warning') {
    color = theme.palette.warning.main;
  }

  return {
    display: 'block',
    marginTop: theme.spacing(0.5),
    fontSize: '0.75rem',
    color,
  };
});
